import React from 'react';
import { Box, Typography, IconButton } from '@material-ui/core';
import { Link } from "react-router-dom";
import { useSelector } from 'react-redux';
import { darkTheme, lightTheme } from '../layout/themes';
import { makeStyles } from '@material-ui/core/styles';
import Arrow from '../assets/icons/white-arrow-left.png'
import GoBackButton from '../CustomizedUIs/GoBackButton';
const useStyles = makeStyles(theme => ({
    TitleCreate: {
        fontFamily: 'UniviaPro-Medium',
        fontSize: '18px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.2,
        letterSpacing: 'normal',
        color: '#4f5064',
    },
    TitleBack: {
        fontFamily: 'UniviaPro-Medium',
        fontSize: '15px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.2,
        letterSpacing: 'normal',
    },
 

}))


const IconTitle = ({ TitleBack, TitleName, pathName }) => {
    const classes = useStyles();
    const theme = useSelector((state) =>
        state.theme === 'dark' ? darkTheme : lightTheme
    );

    return (
        <Box my={2}>
            <Box my={5} width={300} display='flex' component={Link} to={pathName} style={{ textDecoration: 'none' }}>
                <Box display='flex' mr={2}>
                    <GoBackButton />
                 
                </Box>
                <Typography color='primary' className={classes.TitleBack} style={{ margin: 'auto 0' }}>{TitleBack}</Typography>
            </Box>
            <Box display="flex" style={{ marginLeft: "25%" }} >
                <Typography color='primary' className={classes.TitleCreate} style={{ margin: 'auto 0' }}>{TitleName}</Typography>
            </Box>
        </Box>

    )
}
export default IconTitle;